"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var BelowText_1 = __importDefault(require("../BelowText/BelowText"));
var reserveSpace_1 = __importDefault(require("../../utils/reserveSpace"));
var main_1 = require("../../main");
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
/**
 * The Select component is a replacement for the native select, it allows a user to select complex values from a series of text based options. It is often used in forms,
where a user is submitting data.
 */
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearch = function (query) {
            var onSearch = _this.props.onSearch;
            _this.setState({ query: query });
            return onSearch && onSearch(query);
        };
        _this.genOptions = function (options) {
            return options.map(function (item) {
                return __assign({ content: _this.props.search && _this.state.query ? _this.getHighlightedText(item.text, _this.state.query) : React.createElement(React.Fragment, null, item.text) }, item);
            });
        };
        _this.onChangeWrapper = function (event, data) {
            var onChange = _this.props.onChange;
            _this.setState({ values: data.value });
            return onChange && onChange(data.value);
        };
        _this.onLabelClickWrapper = function (event, data) {
            var onLabelClick = _this.props.onLabelClick;
            return onLabelClick && onLabelClick(data.value);
        };
        _this.onCloseWrapper = function (event, data) {
            var onClose = _this.props.onClose;
            _this.setState({ expanded: false });
            return onClose && onClose(data.value);
        };
        _this.onOpenWrapper = function (event, data) {
            _this.setState({ expanded: true });
        };
        _this.onFocusWrapper = function (event, data) {
            var onFocus = _this.props.onFocus;
            return onFocus && onFocus(data.value);
        };
        var open = props.open, defaultValue = props.defaultValue;
        _this.state = {
            values: defaultValue,
            query: '',
            expanded: open ? true : false
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, className = _a.className, error = _a.error, label = _a.label, indicator = _a.indicator, search = _a.search, defaultValue = _a.defaultValue, value = _a.value, onClose = _a.onClose, onFocus = _a.onFocus, open = _a.open, placeholder = _a.placeholder, multiple = _a.multiple, options = _a.options, onChange = _a.onChange, onLabelClick = _a.onLabelClick, fluid = _a.fluid, helperText = _a.helperText, reserveSpace = _a.reserveSpace, onSearch = _a.onSearch, rest = __rest(_a, ["disabled", "className", "error", "label", "indicator", "search", "defaultValue", "value", "onClose", "onFocus", "open", "placeholder", "multiple", "options", "onChange", "onLabelClick", "fluid", "helperText", "reserveSpace", "onSearch"]);
        var isError = error ? true : false;
        return (React.createElement("div", { className: this.genInputClass() },
            label &&
                React.createElement(main_1.InputLabel, { label: label, indicator: indicator }),
            React.createElement(Dropdown_1.default, __assign({}, rest, { search: search, placeholder: placeholder, open: open, multiple: multiple, error: isError, icon: "chevron down", value: value === undefined ? this.state.values : value, disabled: disabled, selection: !disabled, selectOnBlur: false, options: this.genOptions(options), onClose: this.onCloseWrapper, onOpen: this.onOpenWrapper, onFocus: this.onFocusWrapper, onChange: this.onChangeWrapper, onLabelClick: this.onLabelClickWrapper, onSearchChange: function (event, data) { return _this.onSearch(data.searchQuery); }, fluid: fluid })),
            reserveSpace_1.default(this.props) && React.createElement(BelowText_1.default, { error: error, helperText: helperText })));
    };
    Select.prototype.getHighlightedText = function (text, highlight) {
        var highlightWithEscape = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        var parts = text.split(new RegExp("(" + highlightWithEscape + ")", 'gi'));
        return (React.createElement(React.Fragment, null, parts.map(function (part, i) {
            return React.createElement("span", { key: i, className: part.toLowerCase() === highlight.toLowerCase() ? 'select-highlight' : '' }, part);
        })));
    };
    Select.prototype.genInputClass = function () {
        var classString = 'ui scuf-dropdown-wrapper';
        var _a = this.props, options = _a.options, className = _a.className, value = _a.value, fluid = _a.fluid, disabled = _a.disabled;
        var _b = this.state, expanded = _b.expanded, values = _b.values;
        var staticValues = value === undefined ? values : value;
        if (expanded) {
            classString += ' expanded';
        }
        if (staticValues instanceof Array && staticValues.length === options.length) {
            classString += ' no-chevron';
        }
        if (staticValues instanceof Array && staticValues.length) {
            classString += ' has-content';
        }
        if (className) {
            classString += " " + className;
        }
        if (fluid) {
            classString += " fluid";
        }
        if (disabled) {
            classString += " disabled";
        }
        return classString;
    };
    Select.defaultProps = {
        indicator: undefined,
        fluid: false
    };
    return Select;
}(React.Component));
exports.default = Select;
